import React from 'react';
import { SEARCH_PAGE_URL } from 'Routes/constants';
import { t } from 'Src/i18n';
import { TRACK_EVENT_NAMES } from 'Tracking/constants';
import { useTrackEvent } from 'Tracking/tracking-api/useTrackEvent';
import { Button } from 'Components/frameworks/button/Button';
type Props = {
  onRecalculate: () => void;
  total: number;
};
export const GreatMembersPointsSimulatorResult = ({ onRecalculate, total }: Props) => {
  const { trackClickEvent } = useTrackEvent();
  return (
    <div className="sm:flex">
      <div className="mb-20 flex flex-1 flex-col items-center justify-between text-center sm:mb-0 sm:items-start">
        <p className="font-brand text-18 text-black sm:text-24">
          {t('customerAccount.greatMember.pointsSection.simulator.totalPointsLabel')}{' '}
          <span className="block text-24 text-sienna sm:ms-20 sm:inline sm:text-32">
            {t('common.currentPoints', {
              currentPoints: total,
            })}
          </span>
        </p>
        <p className="mt-10 text-10">
          {t('customerAccount.greatMember.pointsSection.simulator.totalPointsNotesLabel')}
        </p>
      </div>
      <div className="flex flex-col items-center justify-between">
        <Button url={SEARCH_PAGE_URL}>{t('common.searchStay')}</Button>
        <Button
          onClick={() => {
            onRecalculate();
            trackClickEvent(TRACK_EVENT_NAMES.CLICK_CA_GM, {
              detail_click: 'replay_point_simulator',
            });
          }}
          theme="link"
        >
          {t('common.recalculate')}
        </Button>
      </div>
    </div>
  );
};
